import { render, staticRenderFns } from "./DeltaAlertTriggered.vue?vue&type=template&id=72fe8f6d&"
import script from "./DeltaAlertTriggered.vue?vue&type=script&lang=js&"
export * from "./DeltaAlertTriggered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports